import { readable, type Readable } from "svelte/store";
import { browser } from "$app/env";

const DESKTOP_QUERY = "(min-width: 768px)";

export function createDesktopStore(isDesktop: boolean): Readable<boolean> {
	return readable<boolean>(browser ? match() : isDesktop, set => {
		if (!browser) return undefined;

		const mql = window.matchMedia(DESKTOP_QUERY);
		// Set immediately (no waiting for resize)
		set(mql.matches);

		function onChange(e: MediaQueryListEvent) {
			set(e.matches);
		}
		// Modern API
		mql.addEventListener("change", onChange);
		return () => mql.removeEventListener("change", onChange);
	});
}

function match() {
	return window.matchMedia(DESKTOP_QUERY).matches;
}
